import {
    ILoyaltyIndicatorOptions,
    ILoyaltyIndicatorViewModel,
    ILoyaltyInitInfo,
    ILoyaltyStyle
} from "./loyalty-indicator-view-model.interface";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {CGPEventSubscription} from "../../sdk/cgp-sdk.interface";
import {MyAccountTab} from "@sparkware/uc-sdk-core";

export class LoyaltyIndicatorModel implements ILoyaltyIndicatorViewModel {
    constructor(private readonly services: IServiceFactoryExtended, private readonly options: ILoyaltyIndicatorOptions) {
        const LoyaltyIndicatorConstructor = this.services.window.getGlobalProperty('rlpfweb').LoyaltyIndication;

        const loyaltyInitInfo: ILoyaltyInitInfo = this._createLoyaltyInfo();

        this._loyaltyRef = new LoyaltyIndicatorConstructor(loyaltyInitInfo);

        this._loyaltyRef.addEventListener('onloyaltydetailsclick', this._clickHandler);

        this.subscription = this.services.sdk.events.onFirebaseGotNewToken(({token}) => this.options.firebaseToken !== token)

    }

    private _createLoyaltyInfo(): ILoyaltyInitInfo {
        return {
            UserInfo: this.options.platformToken,
            FirebaseToken: this.options.firebaseToken,
            CID: this.services.user.cid,
            LanguageCode: this.services.language.currentLanguage,
            ClientContext: {
                BrandId: this.services.sdk.getBrandID(),
                ClientPlatform: this.services.sdk.getSkin().getClientPlatform(),
                ClientVersion: this.services.sdk.getSkin().getVersion(),
                ProductPackage: this.services.sdk.getProductPackageId(),
                SubBrandId: this.services.sdk.getBrandID(),
            },
            Logger: this.services.window.console,
            Style: this._createLoyaltyStyle()
        }
    }

    private _createLoyaltyStyle(): ILoyaltyStyle {

        let loyaltyStyleParams: ILoyaltyStyle = {
            BackgroundColor:"transparent",
            ShowBoxShadow: false,
            ShowUnderline:false,
            FontSize: 16,
            ArrowSize: 9,
            Font: this.services.theme.currentTheme.font.family.body,
            ProgressBarHeight: 4,
            ArrowColor: "#7b7b7b",
            LOLArrowContainerRigh:"5px", 

        }
        if (this.services.mediaQuery.lAndBelow) {
            let mobileParams: ILoyaltyStyle = {
                ...loyaltyStyleParams,
                LOLArrowContainerLeft:"10px",
            }
            return mobileParams;            
        }
        else {
            let pcloyaltyStyle: ILoyaltyStyle = {
                ...loyaltyStyleParams,
                FontSize: 12,
                ArrowSize: 8,
                LOLContentPaddingLeft: 0,
                LOLArrowContainerRigh: "-3px",
                TextColor: "#717171",
                ProgressBarColor: this.services.theme.currentTheme.colors.backgroundMiddleDark,
                ProgressBarBackgroundColor: this.services.theme.currentTheme.colors.backgroundMiddleDark,
                ProgressBarBorderRadius: 8,
                LOLArrowTop: "-3px",
            }
            return pcloyaltyStyle
        }
    }

    private _clickHandler = async () => {
        await this.services.externalLinks.openMyAccount({
            tabId: MyAccountTab.LCChallenges
        });
    }

    private _loyaltyRef;
    private subscription: CGPEventSubscription;

    dispose(): void {
        this.subscription?.off();
        //this._loyaltyRef?.removeEventListener('onloyaltydetailsclick', this._clickHandler) //TO DO Verify with debugger if removeEventListener exist
        this._loyaltyRef?.Terminate();
    }

} 